export default __webpack_public_path__ + "static/media/shape.f31444a3.svg";